import 'rc-slider/assets/index.css';
import './style.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from './actions';
import _ from 'lodash';
import { Range as RcSlider } from 'rc-slider';
import Collapse from 'react-collapse';
import ListOption from './listOption';
import Sort from './sort';
import FilterIcon from 'images/filter-icon.png';
import SortIcon from 'images/sort-icon.png';

let Filter = class Filter extends React.Component {
  constructor() {
    super();
    this.state = {};
    this.sortFilter = ['sort', 'order', 'price', 'skip', 'size'];
  }

  toggle(name) {
    let expand = { ...this.props.expand };
    let value = expand[name] || false;
    expand[name] = !value;
    this.props.updateExpand({ ...expand });
  }

  updatePrice(values) {
    let selected = { ...this.props.selected, skip: 0 };
    const [minPrice, maxPrice] = _.find(this.props.filterset, [
      'name',
      'price'
    ]).values;
    if (minPrice === values[0] && maxPrice === values[1]) {
      delete selected.price;
    } else {
      selected.price = { min: values[0], max: values[1] };
    }
    this.props.selectFilters(selected);
    this.props.history.replace(
      actions.pathForSelected(this.props.location, selected)
    );
  }

  selectedPrice(values) {
    let price = this.props.selected.price;
    if (price) return [price.min, price.max];
    return [this.min(values), this.max(values)];
  }

  min(values) {
    return values[1] == null ? 0 : Math.floor(values[0]);
  }

  max(values) {
    const roundedDown = values[1] == null ? values[0] : values[1];
    return roundedDown + 1;
  }

  removeSelected(key, item) {
    let selected = { ...this.props.selected, skip: 0 };
    selected[key] = _.without(selected[key], item);
    if (!selected[key].length) delete selected[key];
    this.props.selectFilters(selected);
    this.props.history.replace(
      actions.pathForSelected(this.props.location, selected)
    );
  }

  clear() {
    let selected = { ...this.props.selected };
    for (var k in selected) {
      if (this.sortFilter.indexOf(k) != -1) continue;
      delete selected[k];
    }
    this.props.selectFilters(selected);
    this.props.history.replace(
      actions.pathForSelected(this.props.location, selected)
    );
  }

  render() {
    let filterset = { ...this.props.selected };
    let allow = _.keyBy(this.props.filterset, 'name');
    this.sortFilter.forEach(function(item) {
      delete filterset[item];
    });

    _.each(filterset, function(item, k) {
      if (!allow[k]) {
        delete filterset[k];
        return;
      }
      filterset[k] = _.isArray(item) ? item : [item];
      filterset[k] = _.uniq(filterset[k].map(item => item.toLowerCase()));
    });

    this.filterset = _.size(filterset) ? filterset : null;

    return (
      <div className="filter">
        <div
          className="filter-item filter-option"
          style={{ backgroundImage: `url(${FilterIcon})` }}
        >
          <div className="filter-item-container">
            <label className="filter-name">
              Filtering By
              {!!this.filterset && (
                <span
                  onClick={this.clear.bind(this)}
                  className="filter-name-toggle"
                >
                  Clear
                </span>
              )}
            </label>
            <div className="filter-sort-selected">
              {_.map(this.filterset, (filter, filterIndex) => {
                return filter.map(item => (
                  <div key={item}>
                    <div className="filter-sort-selected-item">
                      <span className="filter-sort-selected-title">
                        {item.toLowerCase()}
                      </span>
                      <span
                        className="filter-sort-selected-remove"
                        onClick={this.removeSelected.bind(
                          this,
                          filterIndex,
                          item
                        )}
                      >
                        x
                      </span>
                    </div>
                  </div>
                ));
              })}
            </div>
          </div>
        </div>

        <div
          className="filter-item filter-option"
          style={{ backgroundImage: `url(${SortIcon})` }}
        >
          <div className="filter-item-container">
            <label
              onClick={this.toggle.bind(this, 'sort')}
              className="filter-name"
            >
              Sort
              {!this.props.expand['sort'] && (
                <span className="filter-name-toggle">Hide</span>
              )}
              {this.props.expand['sort'] && (
                <span className="filter-name-toggle">Show</span>
              )}
            </label>
            <Collapse isOpened={!this.props.expand['sort']}>
              <Sort />
            </Collapse>
          </div>
        </div>

        {this.props.filterset.map(item => (
          <Fragment key={item.name}>
            {item.type == 'option' && (
              <div
                className="filter-item filter-option"
                style={{ backgroundImage: `url(${item.icon})` }}
              >
                <div className="filter-item-container">
                  <label
                    onClick={this.toggle.bind(this, item.name)}
                    className="filter-name"
                  >
                    {item.display_name || item.name}
                    {!this.props.expand[item.name] && (
                      <span className="filter-name-toggle">Hide</span>
                    )}
                    {this.props.expand[item.name] && (
                      <span className="filter-name-toggle">Show</span>
                    )}
                  </label>
                  <Collapse isOpened={!this.props.expand[item.name]}>
                    <ListOption {...item} parentSelector=".filter" />
                  </Collapse>
                </div>
              </div>
            )}

            {item.type == 'range' && (
              <div
                className="filter-item filter-range"
                style={{ backgroundImage: `url(${item.icon})` }}
              >
                <div className="filter-item-container">
                  <label className="filter-name">
                    {item.name}
                    <span className="filter-name-toggle">
                      ${this.selectedPrice(item.values)[0]} - ${this.selectedPrice(item.values)[1]}
                    </span>
                  </label>
                  <RcSlider
                    onAfterChange={this.updatePrice.bind(this)}
                    min={this.min(item.values)}
                    max={this.max(item.values)}
                    defaultValue={this.selectedPrice(item.values)}
                    tipFormatter={null}
                  />
                </div>
              </div>
            )}
          </Fragment>
        ))}
      </div>
    );
  }
};

function mapStateToProps(state) {
  return { ...state.filter };
}

Filter = withRouter(Filter);
export default connect(mapStateToProps, { ...actions })(Filter);



// WEBPACK FOOTER //
// ./shared/components/filter/index.js